import { api } from '../../api';

export interface PlaceAutocompleteSuggestion {
  placeId: string;
  /** Venue name, when the suggestion is a business/venue rather than a plain address. */
  name: string | null;
  /** Full address including ZIP, e.g. "4200 E Palm Canyon Dr, Palm Springs, CA 92264, USA". */
  address: string;
}

export const getPlaceAutocompleteSuggestions = async ({
  restaurantId,
  input,
  sessionToken,
}: {
  restaurantId: string;
  input: string;
  sessionToken: string;
}): Promise<PlaceAutocompleteSuggestion[]> => {
  const { suggestions } = await api.get<{
    suggestions: PlaceAutocompleteSuggestion[];
  }>(
    `/restaurants/${restaurantId}/places/autocomplete?input=${encodeURIComponent(
      input,
    )}&sessionToken=${encodeURIComponent(sessionToken)}`,
  );
  return suggestions;
};

export const getPlaceFormattedAddress = async ({
  restaurantId,
  placeId,
  sessionToken,
}: {
  restaurantId: string;
  placeId: string;
  sessionToken: string;
}): Promise<string | null> => {
  const { formattedAddress } = await api.get<{
    formattedAddress: string | null;
  }>(
    `/restaurants/${restaurantId}/places/${encodeURIComponent(
      placeId,
    )}/address?sessionToken=${encodeURIComponent(sessionToken)}`,
  );
  return formattedAddress;
};
